/**
 * Generates a unique ID. 
 * Uses crypto.randomUUID() if available (secure contexts like localhost/HTTPS).
 * Falls back to a robust math-based generator for non-secure contexts (e.g., local network IP).
 */
export const generateUUID = (): string => {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
        return crypto.randomUUID();
    }

    // Robust fallback for non-secure contexts
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};
